import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-transmission" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Comisión"),
  /*#__PURE__*/_createElementVNode("th", null, "Auxilio salarial"),
  /*#__PURE__*/_createElementVNode("th", null, "Auxilio no salarial"),
  /*#__PURE__*/_createElementVNode("th", null, "Bonificación salarial"),
  /*#__PURE__*/_createElementVNode("th", null, "Bonificación no salarial")
], -1)
const _hoisted_3 = { class: "error-transmission" }
const _hoisted_4 = { class: "tooltip-container" }
const _hoisted_5 = { class: "tooltip-container" }
const _hoisted_6 = { class: "tooltip-container" }
const _hoisted_7 = { class: "tooltip-container" }
const _hoisted_8 = { class: "tooltip-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Tooltip = _resolveComponent("Tooltip")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.Commission.$error }]),
            minFractionDigits: 0,
            onBlur: _cache[0] || (_cache[0] = ($event: any) => ($setup.v$.Commission.$touch())),
            modelValue: $setup.CAB.Commissions[0],
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.CAB.Commissions[0]) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.AssistanceTotal.$error }]),
            minFractionDigits: 0,
            onBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.v$.AssistanceTotal.$touch())),
            modelValue: $setup.CAB.Assistances[0].Total,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.CAB.Assistances[0].Total) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.AssistanceNonSalaryTotal.$error }]),
            minFractionDigits: 0,
            onBlur: _cache[4] || (_cache[4] = ($event: any) => ($setup.v$.AssistanceNonSalaryTotal.$touch())),
            modelValue: $setup.CAB.Assistances[0].NonSalaryTotal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.CAB.Assistances[0].NonSalaryTotal) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.BonusTotal.$error }]),
            minFractionDigits: 0,
            onBlur: _cache[6] || (_cache[6] = ($event: any) => ($setup.v$.BonusTotal.$touch())),
            modelValue: $setup.CAB.Bonuses[0].Total,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.CAB.Bonuses[0].Total) = $event))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("td", null, [
          _createVNode(_component_InputNumber, {
            min: 0,
            inputId: "currency-us",
            mode: "currency",
            currency: "COP",
            locale: "es-CO",
            class: _normalizeClass(["pv-input-size", { 'p-invalid': $setup.v$.BonusNonSalaryTotal.$error }]),
            minFractionDigits: 0,
            onBlur: _cache[8] || (_cache[8] = ($event: any) => ($setup.v$.BonusNonSalaryTotal.$touch())),
            modelValue: $setup.CAB.Bonuses[0].NonSalaryTotal,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.CAB.Bonuses[0].NonSalaryTotal) = $event))
          }, null, 8, ["modelValue", "class"])
        ])
      ]),
      _createElementVNode("tr", _hoisted_3, [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.Commission.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.Commission.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.AssistanceTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.AssistanceTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.AssistanceNonSalaryTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.AssistanceNonSalaryTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.BonusTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.BonusTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ]),
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.BonusNonSalaryTotal.$errors, (error) => {
              return (_openBlock(), _createBlock(_component_Tooltip, {
                key: error.$uid,
                visible: $setup.v$.BonusNonSalaryTotal.$error,
                message: error.$message
              }, null, 8, ["visible", "message"]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}